export function mockName(name: string): string {
  if (!name) return '';
  const surnameIndex = name.indexOf(' ') + 1;
  const firstSurnameLetter = surnameIndex ? name.substr(surnameIndex, 1) : '';
  return name.substr(0, 1) + firstSurnameLetter;
}
